export default __webpack_public_path__ + "static/media/item3.68db9451.png";